import { render, staticRenderFns } from "./KeybeLogo.vue?vue&type=template&id=40788f44&"
import script from "./KeybeLogo.vue?vue&type=script&lang=js&"
export * from "./KeybeLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports